import React from 'react';
import PropTypes from 'prop-types';
import Login from '../../../containers/login';
import SignInForm from './sign-in-form';

// Type/Shape pour Testimonial (pour compatibilité avec TypeScript)
export const TestimonialShape = PropTypes.shape({
  avatarSrc: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  handle: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
});

// Composant SignInPage qui wrap le composant Login
const SignInPage = ({
  title,
  description,
  heroImageSrc,
  testimonials = [],
  onSignIn,
  onGoogleSignIn,
  onResetPassword,
  onCreateAccount,
  redirectTo,
}) => {
  return (
    <Login
      title={title}
      description={description}
      heroImageSrc={heroImageSrc}
      testimonials={testimonials}
      onGoogleSignIn={onGoogleSignIn}
      onResetPassword={onResetPassword}
      onCreateAccount={onCreateAccount}
    >
      <SignInForm
        onSignIn={onSignIn}
        onGoogleSignIn={onGoogleSignIn}
        onResetPassword={onResetPassword}
        onCreateAccount={onCreateAccount}
        redirectTo={redirectTo}
      />
    </Login>
  );
};

SignInPage.propTypes = {
  title: PropTypes.node,
  description: PropTypes.node,
  heroImageSrc: PropTypes.string,
  testimonials: PropTypes.arrayOf(TestimonialShape),
  onSignIn: PropTypes.func,
  onGoogleSignIn: PropTypes.func,
  onResetPassword: PropTypes.func,
  onCreateAccount: PropTypes.func,
  redirectTo: PropTypes.string,
};

export { SignInPage };
// Export pour compatibilité TypeScript
export const Testimonial = TestimonialShape;

